<template>
    <div class="container-offset" :style="{'margin-top': (-1 * offset) + 'px'}">
        <div class="container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            offset: Number
        }
    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/globals";
    .container{
        max-width: 1272px;
    }
    .container-offset {
        max-width: 1391px;
        margin: 0 auto;
        padding: 0 58px;
        padding-bottom: 66px;
        background: #fff;
        position: relative;
        z-index: 10;

        @media (max-width: $mq-xl) {
            max-width: none;
            padding: 0;
            padding-bottom: 66px;
            margin-top: 0 !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/ContainerWithOffset.vue